import { Box, Text, Flex } from '@chakra-ui/react'
import { useCoinflipStore } from './CoinflipProvider'
import { GAME_MODE, GameStatus } from './types'
import { motion, useAnimation } from 'framer-motion'
import { memo, useEffect } from 'react'
import { MiniGameStatus } from '@/__generated__/graphql'
import { useTranslation } from 'next-i18next/pages'

export const MultiplierCounter = memo(() => {
  const { t } = useTranslation()
  return (
    <Flex justifyContent={'start'} h={'full'} alignItems={'center'}>
      <Box textAlign={'center'}>
        <Counter />
        <Text fontSize={{ base: 'xs', md: 'sm' }} color={'ninja.200'} fontWeight={700}>
          {t('common.multiplier')}
        </Text>
      </Box>
    </Flex>
  )
})

const Counter = () => {
  const {
    view: { history, status, roundState },
    gameSteps: steps,
    form,
  } = useCoinflipStore()
  const controls = useAnimation()

  useEffect(() => {
    const lastGame = history.at(0)

    if (
      lastGame?.result === MiniGameStatus.Win &&
      ((status !== GameStatus.IDLE && form.fields.mode === GAME_MODE.MULTIPLY) ||
        form.fields.mode === GAME_MODE.INSTANT)
    ) {
      controls.set({ opacity: 1, bottom: '100%', color: '#68f276' })
      controls.start({ opacity: 0, transform: 'translateY(100%)', transition: { duration: 1 } }).then(() => {
        controls.set({ transform: 'translateY(0)' })
      })
    }

    if (lastGame?.result === MiniGameStatus.Lose) {
      controls.set({ opacity: 1, bottom: '0', color: '#ff7d7d' })
      controls.start({ opacity: 0, transform: 'translateY(100%)', transition: { duration: 1 } }).then(() => {
        controls.set({ transform: 'translateY(0)' })
      })
    }
  }, [roundState, history, controls])

  const multiplier =
    form.fields.mode === GAME_MODE.INSTANT
      ? steps?.at?.(1)?.multiplier
      : steps.at(roundState.currentStep)?.multiplier || '0'

  return (
    <Box pos={'relative'} fontSize={{ base: '16px', md: '24px' }}>
      <motion.div
        animate={controls}
        initial={{ opacity: 0 }}
        style={{
          fontWeight: 700,
          position: 'absolute',
          left: 0,
          right: 0,
        }}
      >
        x{multiplier}
      </motion.div>
      <Text fontWeight={700}>x{multiplier}</Text>
    </Box>
  )
}
